<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{data.data ? 'Edit' : 'Add New'}} {{data.title}}
</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <ng-container *ngFor="let field of data.fields; let i = index">
            <mat-form-field
              appearance="fill"
              floatLabel="always"
              *ngIf="!field.invisible?.(form) && !(fieldsOutsideMatFormField.includes(field.fieldType))"
            >
                <mat-label>{{field.label}}</mat-label>

                <!-- String Input -->
                <input *ngIf="field.fieldType === fieldType.F_STRING" matInput placeholder="" [formControlName]="field.name">

                <!-- Number Input -->
                <input *ngIf="field.fieldType === fieldType.F_NUMBER" type="number" matInput placeholder="" [formControlName]="field.name">

                <!-- SSN Input -->
                <input *ngIf="field.fieldType === fieldType.F_SSN" [type]="field.hidePassword ? 'password' : 'text'" pattern="^\d{3}-?\d{2}-?\d{4}$" matInput placeholder="" [formControlName]="field.name">
                <button *ngIf="field.fieldType === fieldType.F_SSN" mat-icon-button matSuffix (click)="field.hidePassword = !field.hidePassword" [attr.aria-label]="'Toggle password visibility'" [attr.aria-pressed]="!field.hidePassword">
                    <mat-icon>{{ field.hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>

                <!-- Phone Input -->
                <input *ngIf="field.fieldType === fieldType.F_PHONE" type="tel" matInput placeholder="" [formControlName]="field.name">

                <!-- Email Input -->
                <input *ngIf="field.fieldType === fieldType.F_EMAIL" type="email" matInput placeholder="" [formControlName]="field.name">
                <mat-error *ngIf="form.get(field.name)?.hasError('required')">
                    {{field.label}} is required
                </mat-error>
                <mat-error *ngIf="form.get(field.name)?.hasError('email')">
                    Please enter a valid email address
                </mat-error>

                <!-- Currency Input -->
                <input *ngIf="field.fieldType === fieldType.F_CURRENCY" type="currency" matInput placeholder="" [formControlName]="field.name">
                <mat-error *ngIf="form.get(field.name)?.hasError('required')">
                    {{field.label}} is required
                </mat-error>
                <mat-error *ngIf="form.get(field.name)?.hasError('currency')">
                    Please enter a valid amount, no $, no commas
                </mat-error>

                <!-- Past/Future Date Input -->
                <input *ngIf="field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE"
                       [matDatepicker]="picker" matInput placeholder=""
                       [formControlName]="field.name" [min]="field.minDate" [max]="field.maxDate">
                <mat-datepicker-toggle matSuffix [for]="picker"
                                       *ngIf="field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE">
                </mat-datepicker-toggle>
                <button
                        *ngIf="form.get(field.name)?.value && (field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE)"
                        mat-icon-button
                        matSuffix
                        aria-label="Clear date"
                        (click)="form.get(field.name)?.reset()"
                        tabindex="-1"
                >
                    <mat-icon>close</mat-icon>
                </button>

                <!-- Color selection -->
                <!-- TODO: implement color selector -->
                <div *ngIf="field.fieldType === fieldType.F_COLOR" class="colorField">
                    <input matInput placeholder="" [formControlName]="field.name">
                    <div class="brandColor" style="background-color: {{form.value[field.name]}}"></div>
                </div>

                <!-- Dropdown -->
                <mat-select *ngIf="field.fieldType === fieldType.F_DROPDOWN" [multiple]="field.multiple" [formControlName]="field.name">
                    <mat-option *ngFor="let value of field.values" [value]="value.split(':')[1] || value">
                        {{value.split(':')[0]}}
                    </mat-option>
                </mat-select>
                <app-state *ngIf="field.fieldType === fieldType.F_STATE" [formControlName]="field.name"></app-state>
                <app-json *ngIf="field.fieldType === fieldType.F_JSON" [formControlName]="field.name"></app-json>
            </mat-form-field>
            <mat-datepicker #picker></mat-datepicker>

            <!-- Slide toggle -->
            <!-- mat-slide-toggle should not be displayed within a mat-form-field, so we create and style
                 separately (source: https://material.angular.dev/components/form-field/overview) -->
            <div *ngIf="field.fieldType === fieldType.F_TOGGLE" class="fieldOutsideMatFormField">
                <mat-label >{{field.label}}</mat-label>
                <mat-slide-toggle [checked]="form.value[field.name]" [formControlName]="field.name"></mat-slide-toggle>
            </div>

            <!-- Image selection -->
            <div *ngIf="field.fieldType === fieldType.F_IMAGE" >
                <mat-label >{{field.label}}</mat-label>
                <div class="fieldOutsideMatFormField">
                    <input accept="image/png, image/jpeg" type="file" (change)="imageFileChange($event, field.name)">
                    <img
                        *ngIf="form.value[field.name + 'ImageDataSrc'] || form.value[field.name]"
                        alt="{{field.label}}"
                        class="brandLogo"
                        src="{{form.value[field.name + 'ImageDataSrc'] || form.value[field.name]}}"
                    >
                </div>
            </div>
        </ng-container>
    </form>
    <span class="required">* Required Field</span>
    <app-inlinemessage *ngIf="errorMessage" level="error" [message]="errorMessage"></app-inlinemessage>
</div>
<div class="buttons" mat-dialog-actions>
    <button mat-raised-button [disabled]="!form.valid" class="donebutton" color="primary" (click)="okClicked()">OK</button>
    <button mat-button (click)="onDismiss()">Cancel</button>
</div>
